<template>
  <div
    class="east-img"
    :style="{ width: imgWidth + 'px', height: imgHeight + 'px' }"
  >
    <img :src="imgSrc" />
    <input
      type="file"
      :accept="imgMime"
      title="点击上传图片"
      @change="readImg"
      ref="file"
    />
  </div>
</template>
<script>
export default {
  name: "east-img",
  data() {
    return {
      imgSrc: this.src,
      imgMime: this.accept,
      imgWidth: this.width,
      imgHeight: this.height
    };
  },
  props: {
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    src: {
      type: String,
      default: "",
      required: true
    },
    accept: {
      type: String,
      default: "image/*"
    }
  },
  watch: {
    src(newVal) {
      this.imgSrc = newVal;
    }
  },
  created() {
    this.loadImg(this.src);
  },

  methods: {
    readImg(e) {
      var file = e.target.files[0];
      this.loadImg(window.URL.createObjectURL(file));
      this.$emit("read", file, this.imgSrc);
    },
    loadImg(img) {
      this.imgSrc = img;
      if (this.width === 0 || this.height === 0) {
        let imgTemp = new Image();
        imgTemp.src = img;
        imgTemp.onload = () => {
          this.imgWidth =
            this.width === 0
              ? Math.max(imgTemp.width, this.imgWidth)
              : this.width;
          this.imgHeight =
            this.height === 0
              ? Math.max(imgTemp.height, this.imgHeight)
              : this.height;
        };
      }
    }
  }
};
</script>

<style lang="less">
.east-img {
  position: relative;
  display: inline-block !important;
  border: 1px solid #eeeded;
  border-radius: 3px;
  background-color: #fcf9f9;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
  }
  input[type="file"] {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1100;
    background: none;
    opacity: 0;
    cursor: pointer;
  }
}
</style>
